import { render, staticRenderFns } from "./AbaIntegracao.vue?vue&type=template&id=3d856ae2&scoped=true"
import script from "./AbaIntegracao.vue?vue&type=script&lang=js"
export * from "./AbaIntegracao.vue?vue&type=script&lang=js"
import style0 from "./AbaIntegracao.vue?vue&type=style&index=0&id=3d856ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d856ae2",
  null
  
)

export default component.exports